<template>
    <div>
        <ul class="action-button-list">
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>آدرس دقیق بارگیری</span>
                    <span>{{ optional.loadingAddress ?? '-' }}</span>
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>آدرس دقیق تخلیه</span>
                    <span>{{ optional.dischargeAddress ?? '-' }}</span>
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>تاریخ اعلام بار</span>
                    <span>{{ cargo.loadingDate }}</span>
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>زمان تحویل بار</span>
                    <span>{{ ' 24 ساعته ' }}</span>
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>نوع بار</span>
                    <span>{{ optional.bulk == 2 ? 'فله' : 'غیر فله' }}</span>
                </a>
            </li>
            
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>محموله خطرناک</span>
                    <span>خیر</span>
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>مبلغ بیمه بار </span>
                    <span>-</span>
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <span>توضیحات</span>
                    <span>{{ cargo.description ?? '-' }}</span>
                </a>
            </li>
            <li class="action-divider"></li>
            <li>
                <a href="#" class="btn btn-list text-danger" :id="'offcanvas_' + loadId" data-bs-dismiss="offcanvas">
                    <span>بستن</span>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: ['optional', 'cargo', 'loadId'],
    name: 'optional',
}
</script>
<style></style>